/* Pagerme pager-system product page (v25) */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var noDec = parts[0];
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function kitCount(value) {
    var m = String(value || '').match(/\d+/);
    return m ? parseInt(m[0], 10) : 0;
  }

  class PmPagerProduct extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-pm-variants]').textContent);
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.logoFee = parseInt(this.dataset.logoFee || '0', 10);
      this.hasLogo = this.dataset.hasLogo === 'true';
      this.kit = this.dataset.kit;
      this.logo = this.dataset.logo || 'No';

      this.kitButtons = Array.prototype.slice.call(this.querySelectorAll('.pm-kit'));
      this.pillButtons = Array.prototype.slice.call(this.querySelectorAll('.pm-pill'));
      this.idInput = this.querySelector('input.product-variant-id');
      this.priceNow = this.querySelector('[data-pm-price]');
      this.summary = this.querySelector('[data-pm-summary]');
      this.submit = this.querySelector('.product-form__submit');
      this.upload = this.querySelector('[data-pm-upload]');
      this.fileInput = this.querySelector('[data-pm-file]');
      this.fileName = this.querySelector('[data-pm-file-name]');

      this.kitButtons.forEach((b) => b.addEventListener('click', () => { this.kit = b.dataset.value; this.render(); }));
      this.pillButtons.forEach((b) => b.addEventListener('click', () => { this.logo = b.dataset.value; this.render(); }));
      if (this.fileInput) {
        this.fileInput.addEventListener('change', () => {
          const f = this.fileInput.files && this.fileInput.files[0];
          this.fileName.textContent = f ? f.name : '';
        });
      }
      this.querySelectorAll('.pm-thumb').forEach((t) => t.addEventListener('click', () => this.showMedia(t.dataset.mediaId)));
      this.render(true);
    }

    current() {
      return this.variants.find((v) => v.option1 === this.kit && (!this.hasLogo || (v.option2 || 'No') === this.logo));
    }

    showMedia(id) {
      this.querySelectorAll('.pm-stage__item').forEach((el) => { el.hidden = el.dataset.mediaId !== String(id); });
      this.querySelectorAll('.pm-thumb').forEach((t) => t.setAttribute('aria-current', t.dataset.mediaId === String(id) ? 'true' : 'false'));
      const active = this.querySelector('.pm-thumb[aria-current="true"]');
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    render(initial) {
      const v = this.current();
      this.kitButtons.forEach((b) => b.setAttribute('aria-pressed', b.dataset.value === this.kit ? 'true' : 'false'));
      this.pillButtons.forEach((b) => b.setAttribute('aria-pressed', b.dataset.value === this.logo ? 'true' : 'false'));
      const n = kitCount(this.kit);
      if (this.upload) this.upload.hidden = !(this.hasLogo && this.logo === 'Yes');

      if (!v) {
        if (this.submit) { this.submit.disabled = true; this.submit.querySelector('span').textContent = this.dataset.unavailableText || 'Unavailable'; }
        return;
      }
      if (this.idInput) { this.idInput.value = v.id; this.idInput.disabled = !v.available; }
      if (this.priceNow) this.priceNow.textContent = formatMoney(v.price, this.moneyFormat);
      if (this.submit) {
        this.submit.disabled = !v.available;
        this.submit.querySelector('span').textContent = v.available ? (this.dataset.addText || 'Add to cart') : (this.dataset.soldOutText || 'Sold out');
      }
      if (this.summary) {
        let s = this.kit + ' kit';
        if (this.hasLogo && this.logo === 'Yes') s += ' + ' + n + ' custom logo prints';
        this.summary.textContent = s;
      }
      if (!initial && v.featured_media && v.featured_media.id) this.showMedia(v.featured_media.id);
      if (!initial && window.history && window.history.replaceState) {
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString());
      }
      document.querySelectorAll('[data-pm-n]').forEach((el) => { el.textContent = n; });
      document.dispatchEvent(new CustomEvent('pm:variant', { detail: { variant: v, n: n, logo: this.logo } }));
    }
  }
  if (!customElements.get('pm-pager-product')) customElements.define('pm-pager-product', PmPagerProduct);

  /* sticky tab highlighting */
  document.addEventListener('DOMContentLoaded', function () {
    const links = Array.prototype.slice.call(document.querySelectorAll('.pm-tabs__link'));
    if (!links.length || !('IntersectionObserver' in window)) return;
    const map = new Map();
    links.forEach((l) => { const t = document.querySelector(l.getAttribute('href')); if (t) map.set(t, l); });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { links.forEach((l) => l.classList.remove('is-active')); map.get(e.target).classList.add('is-active'); } });
    }, { rootMargin: '-40% 0px -55% 0px' });
    map.forEach((_, t) => io.observe(t));
    links.forEach((l) => l.addEventListener('click', (ev) => {
      const t = document.querySelector(l.getAttribute('href'));
      if (!t) return; ev.preventDefault();
      const top = t.getBoundingClientRect().top + window.scrollY - 70;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }));
    const more = document.querySelector('[data-pm-more]');
    if (more) more.addEventListener('click', () => {
      const wrap = more.closest('.pm-desc'); wrap.classList.add('is-open');
      wrap.querySelector('.pm-desc__body').classList.add('is-open'); more.hidden = true;
    });
  });
})();
